import React from "react";
import Svg from "@/Components/Svg";
import useCopyToClipboard from "@/Hooks/useCopyToClipboard";

const Share = (props) => {
    const {product = {}, isMobile = false} = props;
    const {h1 = ''} = product;

    const {copied, copyFn} = useCopyToClipboard();

    /**
     * Кнопка "Поделиться"
     */
    const onShare = () => {
        const url = location.href;

        if (navigator.share && isMobile) {
            shareBrowser(url).then();
        } else {
            copyFn(url);
        }
    }

    /**
     * Открыть браузерное окно с иконками поделиться
     * @param url
     * @returns {Promise<void>}
     */
    const shareBrowser = async (url) => {
        await navigator.share({
            title: '',
            text: h1,
            url,
        });
    }

    return (
        <div className={`additionalInfoContainer__share`}>
            {isMobile ?
                (<Svg id={`shareOutlinedIcon`} className={`svg__share`} onClick={onShare} />) :
                (
                    <>
                        {copied ? (
                            <Svg id={`doneAllOutlinedIcon`} className={`svg--copiedIcon`} onClick={onShare} />
                        ) : (
                            <Svg id={`copyIcon`} className={`svg--copyIcon`} onClick={onShare} />
                        )}
                    </>
                )
            }
        </div>
    );
}

export default Share;
